import React from 'react'
import './index.scss'
import ReviewData from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ReviewStep/ReviewData'
import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'

const ReviewStep = () => (
    <div className="ct-review-step ct-wizard-step-container">
        <CatalogTransferWizardHeader title="Review & Submit">
            <p>
                Please verify all information is correct before clicking <strong>Submit</strong> below.
            </p>
        </CatalogTransferWizardHeader>
        <ReviewData />
    </div>
)

export default ReviewStep
